<template>
  <el-dialog
    title="编辑角色信息"
    :modal-append-to-body="false"
    :append-to-body="true"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    :before-close="handleClose"
    :visible.sync="show"
    width="40%"
  >
    <div class="dialog_box">
      <el-form
        ref="ruleForm"
        :rules="rules"
        :model="editDataInfo"
        label-width="0px"
      >
        <div class="form-row-item-box" style="width:100%">
          <div class="form-item-box" style="width:100%">
            <span>角色名称:</span>
            <el-form-item prop="roleName">
              <el-input
                v-model.trim="editDataInfo.roleName"
                size="small"
                style="width:100%"
                clearable
              ></el-input>
            </el-form-item>
          </div>
        </div>
        <div class="form-row-item-box" style="width:100%">
          <div class="form-item-box" style="width:100%">
            <span>描述:</span>
            <el-form-item prop="roleDescription">
              <el-input
                v-model.trim="editDataInfo.roleDescription"
                size="small"
                style="width:100%"
                type="textarea"
                autosize
                clearable
              ></el-input>
            </el-form-item>
          </div>
        </div>
      </el-form>
      <div class="dialog_save_cancel_box">
        <div class="cancel_item_box" @click="handleClose">取消</div>
        <div class="save_item_box" @click="saveClick('ruleForm')">确定</div>
      </div>
    </div>
  </el-dialog>
</template>

<script>
//这里可以引入其他文件（比如组件，工具js，第三方插件js，json文件，图片文件等等）
//列如：import <<组件名称>> from '《组件路径》';
export default {
  name: "AuthorityEditDialog",
  components: {},
  props: {
    dialogShow: {
      type: Boolean,
      default: {
        return: false
      }
    },
    editInfo: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },
  data() {
    //这里存放数据
    return {
      show: false,
      editDataInfo: {
        roleName: "",
        roleDescription: "",
        schoolId: this.$store.state.schoolId
      },
      rules: {
          roleName:[{ required: true, message: ' ', trigger: 'blur' },],
          roleDescription:[{ required: true, message: ' ', trigger: 'blur' },]
      }
    };
  },
  //监控data中的数据变化
  watch: {
    dialogShow: function(val) {
      if(val) {
        this.show = val;
        this.editDataInfo = {
          roleId: this.editInfo.roleId,
          roleName: this.editInfo.roleName,
          roleDescription: this.editInfo.roleDescription
        }
      }
    }
  },
  //计算属性，类似于data概念
  computed: {},
  //方法集合
  methods: {
    handleClose() {
        this.$emit('close',false);
        this.show = false;
        this.$refs.ruleForm.resetFields();
    },
    saveClick(formName) {
        this.$refs[formName].validate((valid) => {
        if (valid) {
            this.editRoleGetData()
        } else {
          return false;
        }
      });
    },
    // 更新角色数据提交
    async editRoleGetData() {
      let res = await this.$Http.editRoleData(this.editDataInfo);
      if (res.code == 200) {
        this.$message({
          type: "success",
          message: "修改成功！"
        });
        this.editDataInfo.roleId = "";
        this.editDataInfo.roleName = "";
        this.editDataInfo.roleDescription = "";
        this.$emit('close',true);
        this.show = false;
      } else if (res.code == 101) {
      } else {
        this.$message({
          type: "error",
          message: res.messsage
        });
      }
    },
  },
  //生命周期，创建完成（可以访问当前this实例）
  created() {},
  //生命周期，挂载完成（可以访问dom元素）
  mounted() {},
  beforeCreate() {}, //生命周期-创建之前
  beforeMount() {}, //生命周期 - 挂载之前
  beforeUpdate() {}, //生命周期 - 更新之后
  updated() {}, //生命周期 - 更新之后
  beforeDestroy() {}, //生命周期 - 销毁之前
  destroy() {}, //生命周期 - 销毁完成
  activated() {} //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>
<style scoped></style>
